export const DEFAULT_POLLING_INTERVAL = 0.5;
export const DEFAULT_POLLING_TIMEOUT = 3600; // die after an hour, do not DDOS ourselves

export const POLLING_TIMEOUT_MSG = 'polling timeout';
export const POLLING_ABORT_MSG = 'polling aborted';

export const olHeaders = {
  'x-http-caller-id': process.env.npm_package_name,
  'x-http-caller-version': process.env.npm_package_version,
} as const;
